<template>
  <div>
    <svg
      width="245"
      height="327"
      viewBox="0 0 245 327"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.649 288.937C35.0401 224.32 14.7804 99.2946 79.3978 9.68556C144.015 -79.9235 269.04 -100.183 358.649 -35.5658C448.258 29.0516 468.518 154.077 403.901 243.686C339.283 333.295 214.258 353.555 124.649 288.937Z"
        fill="url(#paint0_linear_4980_800)"
      />
      <path
        d="M92.75 234.997C-6.70156 163.282 -29.1866 24.5246 42.5283 -74.927C114.243 -174.379 253.001 -196.864 352.453 -125.149C451.904 -53.4338 474.389 85.324 402.674 184.776C330.959 284.227 192.202 306.712 92.75 234.997Z"
        fill="#2d1b4e"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4980_800"
          x1="424.09"
          y1="215.688"
          x2="35.1898"
          y2="-64.7502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7c3aed" />
          <stop offset="1" stop-color="#7c3aed" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script setup lang="ts"></script>
